<template>
  <a class="dropdown-toggle d-flex flex-column align-items-center justify-content-center"
     href="#"
     data-bs-toggle="dropdown"
     aria-expanded="false"
  >
  <div class="icon-wrapper position-relative">
    <i class="text-center _icon" :class="iconClass"></i>

    <span   v-show="notificationCount > 0"
            class="position-absolute top-5 start-100 translate-middle badge rounded-pill bg-danger _reduced"
            >
        {{ notificationCount }}
    </span>
    </div>
    <span class="bell-label-text btnLnk"
          aria-expanded="false"
    >{{ bellText }}</span>
  </a>
</template>
<script>

export default {
    // notificationType is defined in main.js
    props: ['notificationType', 'iconClass', 'notificationCount'],
    computed: {
        bellText() {
          return window.TXT_OPTIONS[this.notificationType] || "";
        },

        reposition() {
          return '.specific-notify-bell';
          /*
          if (this.notificationType !== 'general') {
              return '.specific-notify-bell';
          } else {
              return '.all-notifys-bell';
          }*/
        }
    }
};
</script>
<style scoped>
.bell-label-text {
  display: none !important; /* Hide on mobile by default */
}


.dropdown-toggle::after {
  display: none;
}

.specific-notify-bell {
  position: absolute;
  top: 1em;
  left: 100%;
}

._icon {
  font-size:24px;
  margin-right:.1em;
  margin-top:.2em;
}
@media (min-width: 992px) {
  .bell-label-text {
    /* Force it to show on desktop regardless of what Vuetify says */
    display: inline !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
}
</style>
